var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookkeepingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 203 203",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_726569792"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M160 0l-116 0c-11,0 -19,8 -19,19l0 166c0,10 8,18 19,18l116 0c10,0 18,-8 18,-18l0 -166c0,-11 -8,-19 -18,-19zm11 185c0,6 -5,11 -11,11l-116 0c-7,0 -12,-5 -12,-11l0 -166c0,-7 5,-12 12,-12l116 0c6,0 11,5 11,12l0 166z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M157 18l-111 0c-2,0 -3,1 -3,3l0 45c0,2 1,3 3,3l111 0c2,0 3,-1 3,-3l0 -45c0,-2 -1,-3 -3,-3zm-3 44l-104 0 0 -37 104 0 0 37 0 0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M57 83l-5 0c-6,0 -11,5 -11,12l0 4c0,6 5,11 11,11l5 0c6,0 11,-5 11,-11l0 -4c0,-7 -5,-12 -11,-12zm4 16c0,3 -2,5 -4,5l-5 0c-2,0 -4,-2 -4,-5l0 -4c0,-3 2,-5 4,-5l5 0c2,0 4,2 4,5l0 4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M88 83l-4 0c-7,0 -12,5 -12,12l0 4c0,6 5,11 12,11l4 0c6,0 11,-5 11,-11l0 -4c0,-7 -5,-12 -11,-12zm5 16c0,3 -2,5 -5,5l-4 0c-3,0 -5,-2 -5,-5l0 -4c0,-3 2,-5 5,-5l4 0c3,0 5,2 5,5l0 4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M119 83l-4 0c-6,0 -11,5 -11,12l0 4c0,6 5,11 11,11l4 0c7,0 12,-5 12,-11l0 -4c0,-7 -5,-12 -12,-12zm5 16c0,3 -2,5 -5,5l-4 0c-2,0 -4,-2 -4,-5l0 -4c0,-3 2,-5 4,-5l4 0c3,0 5,2 5,5l0 4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M151 83l-4 0c-7,0 -12,5 -12,12l0 4c0,6 5,11 12,11l4 0c6,0 11,-5 11,-11l0 -4c0,-7 -5,-12 -11,-12zm5 16c0,3 -3,5 -5,5l-4 0c-3,0 -5,-2 -5,-5l0 -4c0,-3 2,-5 5,-5l4 0c2,0 5,2 5,5l0 4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M57 117l-5 0c-6,0 -11,5 -11,11l0 5c0,6 5,11 11,11l5 0c6,0 11,-5 11,-11l0 -5c0,-6 -5,-11 -11,-11zm4 16c0,2 -2,4 -4,4l-5 0c-2,0 -4,-2 -4,-4l0 -5c0,-2 2,-4 4,-4l5 0c2,0 4,2 4,4l0 5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M88 117l-4 0c-7,0 -12,5 -12,11l0 5c0,6 5,11 12,11l4 0c6,0 11,-5 11,-11l0 -5c0,-6 -5,-11 -11,-11zm5 16c0,2 -2,4 -5,4l-4 0c-3,0 -5,-2 -5,-4l0 -5c0,-2 2,-4 5,-4l4 0c3,0 5,2 5,4l0 5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M119 117l-4 0c-6,0 -11,5 -11,11l0 5c0,6 5,11 11,11l4 0c7,0 12,-5 12,-11l0 -5c0,-6 -5,-11 -12,-11zm5 16c0,2 -2,4 -5,4l-4 0c-2,0 -4,-2 -4,-4l0 -5c0,-2 2,-4 4,-4l4 0c3,0 5,2 5,4l0 5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M57 151l-5 0c-6,0 -11,5 -11,11l0 5c0,6 5,11 11,11l5 0c6,0 11,-5 11,-11l0 -5c0,-6 -5,-11 -11,-11zm4 16c0,2 -2,4 -4,4l-5 0c-2,0 -4,-2 -4,-4l0 -5c0,-2 2,-4 4,-4l5 0c2,0 4,2 4,4l0 5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M88 151l-4 0c-7,0 -12,5 -12,11l0 5c0,6 5,11 12,11l4 0c6,0 11,-5 11,-11l0 -5c0,-6 -5,-11 -11,-11zm5 16c0,2 -2,4 -5,4l-4 0c-3,0 -5,-2 -5,-4l0 -5c0,-2 2,-4 5,-4l4 0c3,0 5,2 5,4l0 5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M119 151l-4 0c-6,0 -11,5 -11,11l0 5c0,6 5,11 11,11l4 0c7,0 12,-5 12,-11l0 -5c0,-6 -5,-11 -12,-11zm5 16c0,2 -2,4 -5,4l-4 0c-2,0 -4,-2 -4,-4l0 -5c0,-2 2,-4 4,-4l4 0c3,0 5,2 5,4l0 5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M151 117l-4 0c-7,0 -12,5 -12,11l0 39c0,6 5,11 12,11l4 0c6,0 11,-5 11,-11l0 -39c0,-6 -5,-11 -11,-11zm5 50c0,2 -3,4 -5,4l-4 0c-3,0 -5,-2 -5,-4l0 -39c0,-2 2,-4 5,-4l4 0c2,0 5,2 5,4l0 39z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookkeepingIcon);
export default __webpack_public_path__ + "static/media/BookkeepingIcon.2b51a2b28bfb8e7ea4f76b09e6c3e2e9.svg";
export { ForwardRef as ReactComponent };